module.exports = __webpack_public_path__ + "img/complex.a0954215.png";